export { default } from './deepmerge';
export * from './deepmerge';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/deepmerge/index.js
// module id = 37
// module chunks = 22